var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"align-self-start",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',[(_vm.winStep == 0)?_c('Login',{on:{"stepper":_vm.winStepper}}):_vm._e()],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }